import { type ActorSubclass, type HttpAgent } from '@icp-sdk/core/agent'
import { Principal } from '@icp-sdk/core/principal'
import { config } from '../appConfig'
import {
  CanisterInfo,
  idlFactory as idlTopUpFactory,
  _SERVICE as TopUpFactory,
} from '../idls/topUp/topUp'
import { createActor } from '../utils/createActor'

export const TOP_UP_CANISTER_ID = 'brqa2-2yaaa-aaaad-aal2a-cai'

export class TopUp {
  private actor: ActorSubclass<TopUpFactory>
  private anonymousActor: ActorSubclass<TopUpFactory>

  constructor(identifiedAgent: HttpAgent) {
    this.anonymousActor = createActor(idlTopUpFactory, {
      canisterId: TOP_UP_CANISTER_ID,
      agent: config.getAgent(),
    })

    this.actor = createActor(idlTopUpFactory, {
      canisterId: TOP_UP_CANISTER_ID,
      agent: identifiedAgent,
    })
  }

  getTopUpHistory(user: Principal) {
    return this.anonymousActor.get_top_up_history(user)
  }

  getProfile(user: Principal) {
    return this.anonymousActor.get_profile(user)
  }

  deleteCanister(canister: Principal) {
    return this.actor.delete_canister(canister)
  }

  registerManualTopup(canister: string, amount: bigint) {
    return this.actor.add_top_up_history({
      topup_type: [{ Manual: null }],
      canister: Principal.from(canister),
      timestamp: BigInt(Date.now() * 1_000_000),
      amount,
    })
  }

  async addCanister(canister: CanisterInfo) {
    const result = await this.actor.add_canister(canister)

    if ('Ok' in result) {
      return result.Ok
    } else {
      throw result.Err
    }
  }

  async updateCanister(canister: CanisterInfo) {
    const { id, name, topup_amount, min_cycles, auto_topup, topup_type } = canister

    const result = await this.actor.update_canister_settings(
      id,
      [name],
      [topup_amount],
      [min_cycles],
      [auto_topup],
      [topup_type]
    )

    if ('Ok' in result) {
      return result.Ok
    } else {
      throw result.Err
    }
  }
}
